// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── List page (.vendor-contracts-page) ─────────────────────── */

.vendor-contracts-page .vc-title-cell {
  min-width: 0;
  overflow-wrap: anywhere;
}

.vendor-contracts-page .vc-meta {
  color: var(--ds-text-2);
  font-size: 13px;
  margin: 2px 0 4px;
}

.vendor-contracts-page .vc-small {
  display: block;
  font-size: 12px;
}

.vendor-contracts-page .vc-empty-text {
  max-width: 560px;
  margin-inline: auto;
}

@media (min-width: 768px) {
  .vendor-contracts-page .vc-filter-select {
    min-width: 170px;
  }
}

/* ── Upload modal (.vc-upload-modal, rendered in a portal) ──── */

.vc-upload-modal .vc-upload-note {
  margin-top: 12px;
  margin-bottom: 0;
  font-size: 12px;
}

.vc-upload-modal .vc-upload-progress {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: 32px 8px;
  text-align: center;
}

/* ── Edit drawer (.vc-drawer, rendered in a portal) ─────────── */

.vc-drawer .vc-warnings {
  margin: 0;
  padding-inline-start: 18px;
  overflow-wrap: anywhere;
}

.vc-drawer .vc-model-note {
  display: block;
  margin-top: 16px;
  text-align: end;
}

/* "Other terms" rows: label, value, remove button. */
.vc-drawer .vc-keyfact {
  display: flex;
  align-items: flex-start;
  gap: var(--ds-space-2);
}

.vc-drawer .vc-keyfact-label {
  flex: 0 1 200px;
  min-width: 0;
}

.vc-drawer .vc-keyfact-value {
  flex: 1 1 auto;
  min-width: 0;
}

@media (max-width: 767.98px) {
  .vc-drawer .vc-keyfact-label {
    flex-basis: 40%;
  }

  .vc-drawer .vc-drawer-actions {
    display: flex;
    width: 100%;
  }

  .vc-drawer .vc-drawer-actions > .ant-space-item {
    flex: 1 1 0;
  }

  .vc-drawer .vc-drawer-actions .ant-btn {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/serviceProvider/components/vendorContracts/vendorContracts.css"],"names":[],"mappings":"AAAA,kEAAkE;;AAElE;EACE,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA,kEAAkE;;AAElE;EACE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,kEAAkE;;AAElE;EACE,SAAS;EACT,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA,qDAAqD;AACrD;EACE,aAAa;EACb,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":["/* ── List page (.vendor-contracts-page) ─────────────────────── */\n\n.vendor-contracts-page .vc-title-cell {\n  min-width: 0;\n  overflow-wrap: anywhere;\n}\n\n.vendor-contracts-page .vc-meta {\n  color: var(--ds-text-2);\n  font-size: 13px;\n  margin: 2px 0 4px;\n}\n\n.vendor-contracts-page .vc-small {\n  display: block;\n  font-size: 12px;\n}\n\n.vendor-contracts-page .vc-empty-text {\n  max-width: 560px;\n  margin-inline: auto;\n}\n\n@media (min-width: 768px) {\n  .vendor-contracts-page .vc-filter-select {\n    min-width: 170px;\n  }\n}\n\n/* ── Upload modal (.vc-upload-modal, rendered in a portal) ──── */\n\n.vc-upload-modal .vc-upload-note {\n  margin-top: 12px;\n  margin-bottom: 0;\n  font-size: 12px;\n}\n\n.vc-upload-modal .vc-upload-progress {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 12px;\n  padding: 32px 8px;\n  text-align: center;\n}\n\n/* ── Edit drawer (.vc-drawer, rendered in a portal) ─────────── */\n\n.vc-drawer .vc-warnings {\n  margin: 0;\n  padding-inline-start: 18px;\n  overflow-wrap: anywhere;\n}\n\n.vc-drawer .vc-model-note {\n  display: block;\n  margin-top: 16px;\n  text-align: end;\n}\n\n/* \"Other terms\" rows: label, value, remove button. */\n.vc-drawer .vc-keyfact {\n  display: flex;\n  align-items: flex-start;\n  gap: var(--ds-space-2);\n}\n\n.vc-drawer .vc-keyfact-label {\n  flex: 0 1 200px;\n  min-width: 0;\n}\n\n.vc-drawer .vc-keyfact-value {\n  flex: 1 1 auto;\n  min-width: 0;\n}\n\n@media (max-width: 767.98px) {\n  .vc-drawer .vc-keyfact-label {\n    flex-basis: 40%;\n  }\n\n  .vc-drawer .vc-drawer-actions {\n    display: flex;\n    width: 100%;\n  }\n\n  .vc-drawer .vc-drawer-actions > .ant-space-item {\n    flex: 1 1 0;\n  }\n\n  .vc-drawer .vc-drawer-actions .ant-btn {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
